import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { FileCode } from 'lucide-react';
import { noteTemplateTriggerClasses } from './noteInstructions.styles';
import type { NoteTemplateSelectProps } from './noteInstructions.types';

/** The note's template, as a dropdown at the start of the toolbar. */
export const NoteTemplateSelect = ({ templates, value, open, onOpenChange, onSelect }: NoteTemplateSelectProps) => (
  <Select
    open={open}
    onOpenChange={onOpenChange}
    value={value?.toString() ?? ''}
    onValueChange={(next) => onSelect(Number.parseInt(next))}
  >
    <SelectTrigger className={noteTemplateTriggerClasses} aria-label="Sniðmát">
      <FileCode className="h-4 w-4 shrink-0 text-muted-foreground" aria-hidden />
      <SelectValue placeholder="Veldu sniðmát..." />
    </SelectTrigger>
    <SelectContent>
      {templates.map((template) => (
        <SelectItem key={template.id} value={template.id.toString()}>
          {template.name}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
